/* src/app/modules/portal/components/release-notes/release-notes.component.scss */
.releaseNotesPage {
  display: flex;
  background: var(--base-0);
}
.ReleaseNotesHeader {
  margin-bottom: 1rem;
  font-size: 2em;
}
.ReleaseNotesContent {
  margin: 0 auto;
  width: 70%;
}
.stickyHeader {
  padding: 20px 0px 0px 0px;
  width: 100%;
  position: sticky;
  top: 72px;
  background: var(--base-0);
  z-index: 2;
}
.searchYearWrapper {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.searchBarWrapper {
  display: flex;
  width: 60%;
}
.searchBarWrapper #searchInput {
  width: 70%;
}
.search-navigation {
  padding-left: 2%;
  display: flex;
  align-items: center;
}
.match-count {
  font-size: 0.875rem;
  color: var(--text-secondary);
}
:host ::ng-deep .search-highlight {
  background-color: rgba(255, 255, 0, 0.4);
}
:host ::ng-deep .search-highlight.active {
  background-color: rgba(255, 165, 0, 0.6);
}
.yearSelection {
  width: 20%;
}
.featuresContent {
  padding-top: 2rem;
  width: 100%;
}
.featuresContent .featureList .featureDescription {
  padding-bottom: 1%;
}
.featureImage {
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.featureImage img {
  max-width: calc(100% - 4rem);
}
.versionContent {
  margin-bottom: 5%;
}
.versionHeader,
.featureList {
  margin-bottom: 1%;
}
.versionHeader .versionName,
.featureList .versionName {
  font-size: 1.5rem;
}
[screen-tablet] :host-context .ReleaseNotesHeader,
[screen-phone] :host-context .ReleaseNotesHeader {
  margin-bottom: 0.4rem;
  width: 90%;
}
[screen-tablet] :host-context .ReleaseNotesContent,
[screen-phone] :host-context .ReleaseNotesContent {
  margin: 0 auto;
  width: 90%;
}
[screen-tablet] :host-context .stickyHeader,
[screen-phone] :host-context .stickyHeader {
  top: 56px;
}
[screen-tablet] :host-context sh-text[slot=functions],
[screen-phone] :host-context sh-text[slot=functions] {
  display: block;
}
[screen-tablet] :host-context .yearSelection,
[screen-phone] :host-context .yearSelection {
  width: 25%;
}
[screen-tablet] :host-context .featureImage,
[screen-phone] :host-context .featureImage {
  height: 50%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
[screen-tablet] :host-context .featureImage img,
[screen-phone] :host-context .featureImage img {
  max-width: calc(100% - 2rem);
  max-height: calc(100% - 4rem);
}
/*# sourceMappingURL=release-notes.component.css.map */
